import { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import Categories from 'src/categories/components/Root';
import Header from 'src/common/components/Header';
import Layout from 'src/common/components/Layout';
import DescriptionMetaTag from 'src/common/components/MetaTags/DescriptionMetaTag';
import SearchInputProvider from 'src/common/components/Search/SearchInputProvider';
import { AuthUserApiResponse } from 'src/common/types/api/v4/auth/user';
import handleApiErrors from 'src/common/utils/handleApiErrors';
import serverGetUser from 'src/common/utils/serverGetUser';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';
import withCommonMiddleware from 'src/common/utils/withCommonMiddleware';

type CategoriesPageProps = {
  user: Partial<AuthUserApiResponse>;
};

const CategoriesPage: NextPage = () => {
  const [t] = useTranslation('categories');

  return (
    <>
      <Head>
        <title>{t('categories-title')}</title>
      </Head>
      <DescriptionMetaTag content={t('categories--meta-description')} />
      <Layout>
        <SearchInputProvider>
          <Header withSearch />
          <Categories />
        </SearchInputProvider>
      </Layout>
    </>
  );
};

export const getServerSideProps = handleApiErrors(
  withCommonMiddleware<CategoriesPageProps>(
    async (context) => {
      const userPromise = serverGetUser(context);
      const translationPromise = loadTranslations(
        context.locale,
        [
          'common',
          'categories',
          'navbar',
          'destination-navigation',
          'search-and-filters',
          'boat-categories',
          'boat-type-cards',
          'footer',
        ],
      );

      return {
        props: {
          user: await userPromise,
          ...(await translationPromise),
        },
      };
    },
  ),
);

export default CategoriesPage;
